import { Component, OnInit, ViewChild, AfterViewInit, Inject, ElementRef } from '@angular/core';
import { fromEvent } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

const windowScrolled = fromEvent(window, 'scroll');

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit, AfterViewInit {
  isServicesSectionOnScreen: Boolean = false;
  @ViewChild('servicesSection', { static: false, read: ElementRef }) servicesSectionRef: ElementRef;

  constructor(
    @Inject('VIEWPORT_HEIGHT') private viewportHeight: any
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    windowScrolled
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        const scrollPosition = window.pageYOffset;
        const viewportHeightOffset = this.viewportHeight / 3;
        const servicesSectionPosition = this.servicesSectionRef.nativeElement.offsetTop;

        if (scrollPosition >= servicesSectionPosition - viewportHeightOffset) {
          this.isServicesSectionOnScreen = true;
        }
      });
  }
}
